import React, { useRef, useState } from 'react';
import Button from '../../bootstrap/Button.jsx';
import { FaIcon } from '../Icons.jsx';
import styles from './ImageUploader.module.scss';
import ImageAttachment from '../../dashboard_gen2/gen2_widgets/ImageAttachment.jsx';
import CustomUploadUppy from '../uppy_upload/CustomUploadUppy.jsx';

function ImageUploader({
  value = null,
  onChange = () => {},
  permissions = { public: true },
  minCroppedWidth = null,
  minCroppedHeight = null,
  maxCroppedWidth = null,
  maxCroppedHeight = null,
  minImageDimensions,
  allowedFileTypes,
  info,
  variantSet,
  editorOpts = {},
  previewBackground = false
}) {
  const [showUpload, setShowUpload] = useState(false);
  const cropperRef = useRef(null)

  const handleUploadClick = (e) => {
    e.preventDefault();
    setShowUpload(true);
  }

  const uploadCallback = (res) => {
    const {attachment_id, path, metadata} = res;
    onChange({ attachment_id: attachment_id, path: path, filename: metadata.filename });
  }

  const handleDeleteClick = (e) => {
    e.preventDefault();
    onChange(null);
  }

  return (
    <div>
      {showUpload ? <>
        <div>
          <CustomUploadUppy
            name={'custom-image-upload'}
            maxFileSize={2000000}
            maxNumberOfFiles={1}
            allowedFileTypes={allowedFileTypes || ['.jpeg', '.jpg', '.png', '.webp', '.svg']}
            permissions={permissions}
            height={500}
            uploadCallback={uploadCallback}
            useEditor={true}
            minImageDimensions={minImageDimensions}
            variantSet={variantSet}
            editorOpts={{
              cropper: {
                viewMode: 1,
                minCropBoxWidth: 0,
                minCropBoxHeight: 0,
                crop(event) {
                  const cropper = event.target.cropper;
                  const { width, height } = event.detail;

                  const newData = {}
                  if (maxCroppedWidth != null && width > maxCroppedWidth) {
                    newData.width = Math.min(maxCroppedWidth, width);
                  }
                  if (maxCroppedHeight != null && height > maxCroppedHeight) {
                    newData.height = Math.min(maxCroppedHeight, height);
                  }

                  if (minCroppedWidth != null && width < minCroppedWidth) {
                    newData.width = Math.max(minCroppedWidth, width);
                  }
                  if (minCroppedHeight != null && height < minCroppedHeight) {
                    newData.height = Math.max(minCroppedHeight, height);
                  }

                  if (Object.keys(newData).length) {
                    cropper.setData(newData);
                  }
                },
                ...editorOpts.cropper
              },
              actions: {
                cropSquare: false,
                cropWidescreen: false,
                cropWidescreenVertical: false,
                ...editorOpts.actions
              },
            }}
          />
          {info}
        </div>
      </>
      : <div className={styles['upload-button-container']}>
          <div className={styles['image']} onClick={handleUploadClick}>
            {value?.path ? (
              <ImageAttachment path={value.path} previewBackground={previewBackground} />
            ) : (
              <FaIcon type="image" />
            )}
          </div>
          <div className={styles['buttons-container']}>
            <Button type='danger' onClick={handleDeleteClick}>
              <FaIcon type='trash-o' />
            </Button>
            <Button type='primary' onClick={handleUploadClick}>
              <FaIcon type='upload' />
            </Button>
          </div>
      </div>}
    </div>
  )
}

export default ImageUploader;